import { render } from "./FooterSubscribe.vue?vue&type=template&id=3de0abe1&scoped=true"
import script from "./FooterSubscribe.vue?vue&type=script&lang=js"
export * from "./FooterSubscribe.vue?vue&type=script&lang=js"

import "./FooterSubscribe.vue?vue&type=style&index=0&id=3de0abe1&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de0abe1"]])

export default __exports__